export default __webpack_public_path__ + "static/media/3Pools-logo.de42ee21.png";